import { EActivityType } from '@constants';
import { IActivity } from '@sdk/contracts';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import { Icon } from '@/components/Icon';
import { ACTIVITY_ICONS } from '@/constants';

type Props = {
  resource: Pick<IActivity, '_id' | 'type'>;
};

export const TypeCell: React.FC<Props> = ({ resource }) => {
  const { t } = useTranslation('ProblemReportsTranslations');

  const activityType = resource?.type ?? EActivityType.QUIZ;
  const iconType = ACTIVITY_ICONS[activityType] ?? ACTIVITY_ICONS[EActivityType.QUIZ];

  return (
    <Tooltip title={t(activityType)}>
      <span style={{ display: 'flex', alignItems: 'center' }}>
        <Icon i={iconType} />
      </span>
    </Tooltip>
  );
};
